import {Injectable} from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
    providedIn: 'root'
})
export class EnquiryService extends BaseService {

    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    create(data: any): Observable<any> {
        return this.postRequest(AppUrl.ENQUIRY(), data);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.ENQUIRY(), data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.ENQUIRY(id));
    }
}
